<script setup>
import { computed, defineProps } from 'vue';
import { useI18n } from '@/utils/use-vue2-plugins';

const props = defineProps({
  frequency: {
    type: String,
    required: true
  }
});

const { t } = useI18n();

const hint = computed(() => {
  if (!props.frequency || props.frequency === 'single') {
    return;
  }
  return t(`frequencyHint.${props.frequency}`);
});
</script>

<template>
  <div v-if="hint" class="flex items-center font-medium">
    <span class="text-black-01 text-base leading-4.5">/</span>
    <span class="text-black-01 text-xs leading-normal">{{ hint }}</span>
  </div>
</template>
